import { render, staticRenderFns } from "./categories.vue?vue&type=template&id=16e504e4&scoped=true"
import script from "./categories.vue?vue&type=script&lang=js"
export * from "./categories.vue?vue&type=script&lang=js"
import style0 from "./categories.vue?vue&type=style&index=0&id=16e504e4&prod&lang=scss"
import style1 from "./categories.vue?vue&type=style&index=1&id=16e504e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e504e4",
  null
  
)

export default component.exports